<a
  href="#content-layout-body"
  class="skip-link"
  tabindex="0"
  (click)="onSkipToContent($event)"
>
  Skip to Content
</a>

<div aria-live="polite" aria-atomic="true" role="status" class="sr-only">
  {{ announcement() }}
</div>

@if (loadingService.isGlobalLoading()) {
  <div
    class="global-loading-spinner"
    rvSpinner="_rv-global-spinner"
    [rvShowSpinner]="true"
    role="status"
    aria-label="Loading content"
    aria-busy="true"
  ></div>
}

@if (hideNavigation !== undefined) {
  <div class="app-shell">
    @if (!hideNavigation) {
      <div
        class="past-due-banner-wrapper"
        resizeObserver
        (resizeEvent)="onBannerResize($event)"
      >
        <past-due-banner></past-due-banner>
      </div>
    }
    <mat-sidenav-container>
      <mat-sidenav
        [fixedInViewport]="true"
        [fixedTopGap]="hideNavigation ? 0 : bannerHeight()"
        [mode]="isMobile() ? 'over' : 'side'"
        [opened]="!hideNavigation && sidenavState !== 'closed'"
        (openedChange)="onOpenedChange($event)"
        [@sidenavAnimation]="sidenavState"
        [disableClose]="!isMobile()"
        (@sidenavAnimation.start)="onAnimationStart($event)"
        (@sidenavAnimation.done)="onAnimationDone($event)"
      >
        <sidebar
          [state]="sidenavState"
          [isMobile]="isMobile"
          [parentAnimating]="isAnimating"
          [currentRoute]="currentRoute"
          [hideNavigation]="hideNavigation"
          (companyMenuOpened)="companyMenuOpened = $event"
          (toggleSidenav)="toggleSidenav()"
        >
        </sidebar>
      </mat-sidenav>
      <mat-sidenav-content [@sidenavContentAnimation]="sidenavState">
        <div id="content-layout">
          <div
            id="content-layout-header"
            resizeObserver
            (resizeEvent)="onHeaderResize($event)"
          >
            <common-header
              [hideNavigation]="hideNavigation"
              [currentRoute]="currentRoute"
              (openMobileMenu)="openMobileMenu()"
              (toggleNavigation)="toggleHeaderNavigation()"
            ></common-header>
          </div>
          <div #contentLayoutBody id="content-layout-body" tabindex="-1">
            <ui-view></ui-view>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
}
